import aptitudeDetailGetter from './aptitudeDetailGetter/index'
import contractDetailGetter from './contractDetailGetter/index'
import otherInfoGetter from './otherInfoGetter/index'

export default {
  ...aptitudeDetailGetter,
  ...contractDetailGetter,
  ...otherInfoGetter
}
